import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Route Service
 * Rota bazlı otobüs API'leri için servis
 */
export const busRouteService = {
  /**
   * Rotanın en ucuz seferlerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Origin": "istanbul",
   *   "Destination": "ankara",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCheapestTrips: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getCheapestTrips,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rota bilgilerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Origin": "istanbul",
   *   "Destination": "ankara",
   *   "CurrencyCode": "TRY"
   * }
   */
  getRouteInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getRouteInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rotanın popüler firmalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Origin": "istanbul",
   *   "Destination": "ankara"
   * }
   */
  getPopularCompanies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getPopularCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rota hakkında bilgileri getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Origin": "istanbul",
   *   "Destination": "ankara",
   *   "CurrencyCode": "TRY"
   * }
   */
  getRouteAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getRouteAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rota sık sorulan sorularını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY",
   *   "Origin": "istanbul",
   *   "Destination": "ankara"
   * }
   */
  getRouteSss: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getRouteSss,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rota için otobüs terminallerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Slug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Slug": "istanbul"
   * }
   */
  getRouteBusStations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getRouteBusStations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Rotanın diğer seyahat seçeneklerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Origin - Kalkış noktası (örn: "istanbul-avrupa")
   * @param {string} payload.Destination - Varış noktası (örn: "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Origin": "istanbul-avrupa",
   *   "Destination": "ankara",
   *   "CurrencyCode": "TRY"
   * }
   */
  getOtherTravelOptions: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.route.getOtherTravelOptions,
      payload,
      headers,
      hasErrorHandler,
    }),
};
